import { BluetoothFingerprintScanner } from '../services/fp-service';
let batteryTimeoutId = null;
const scanner = new BluetoothFingerprintScanner();
const setErrorListeners = (context, reject) => {
  scanner.once('connectionError', (e) => {
    context.commit('setIsScanning', false);
    context.commit('setIsConnected', false);
    context.commit('setConnectionError', e);
    clearInterval(batteryTimeoutId);
    reject(e);
  });
  scanner.once('commandError', (e) => {
    context.commit('setIsScanning', false);
    context.commit('setConnectionError', e);
    reject(e);
  });
};
export const fpScanner = {
  state: {
    deviceName: '',
    isScanning: false,
    isChoosingDevice: false,
    isConnecting: false,
    isConnected: false,
    connectionError: null,
    battery: 100,
  },
  getters: {
    deviceName(state) {
      return state.deviceName;
    },
    isScanning(state) {
      return state.isScanning;
    },
    isConnecting(state) {
      return state.isConnecting;
    },
    isConnected(state) {
      return state.isConnected;
    },
    isChoosingDevice(state) {
      return state.isChoosingDevice;
    },
    connectionError(state) {
      return state.connectionError;
    },
    deviceBattery(state) {
      return state.battery;
    },
  },
  mutations: {
    setDeviceName(state, deviceName) {
      state.deviceName = deviceName;
    },
    setIsScanning(state, isScanning) {
      state.isScanning = isScanning;
    },
    setIsConnecting(state, isConnecting) {
      state.isConnecting = isConnecting;
    },
    setIsChoosingDevice(state, isChoosingDevice) {
      state.isChoosingDevice = isChoosingDevice;
    },
    setIsConnected(state, isConnected) {
      state.isConnected = isConnected;
    },
    setConnectionError(state, connectionError) {
      state.connectionError = connectionError;
    },
    setBattery(state, battery) {
      state.battery = battery;
    },
  },
  actions: {
    async connectDevice(context) {
      try {
        context.commit('setIsChoosingDevice', true);
        const device = await scanner.connect();
        context.commit('setDeviceName', device.name);
        context.commit('setIsChoosingDevice', false);

        scanner.once('disconnect', () => {
          context.commit('setIsConnected', false);
          context.commit('setIsScanning', false);
          clearInterval(batteryTimeoutId);
        });
        context.commit('setIsConnecting', true);
        await scanner.connectService();
        context.commit('setIsConnected', true);

        context.dispatch('getBattery');
        batteryTimeoutId = setInterval(() => {
          context.dispatch('getBattery');
        }, 30 * 1000);
      } catch (e) {
        console.error(e);
        context.commit('setConnectionError', e);
      } finally {
        context.commit('setIsConnecting', false);
      }
    },
    async getBattery(context) {
      return new Promise((resolve, reject) => {
        scanner.once('battery', (data) => {
          context.commit('setBattery', data);
          resolve(data);
        });
        scanner.getBattery().catch((e) => {
          reject(e);
        });
      });
    },
    async captureFp(context) {
      return new Promise((resolve, reject) => {
        scanner.once('capture', (data) => {
          context.commit('setIsScanning', false);
          resolve(data);
        });
        context.commit('setIsScanning', true);
        setErrorListeners(context, reject);
        scanner.captureFingerprint().catch((e) => {
          context.commit('setIsScanning', false);
          context.commit('setIsConnected', false);
          reject(e);
        });
      });
    },
    async enrollFp(context) {
      return new Promise((resolve, reject) => {
        scanner.once('enroll', (data) => {
          context.commit('setIsScanning', false);
          resolve(data);
        });
        context.commit('setIsScanning', true);
        setErrorListeners(context, reject);
        scanner.enrollFingerprint().catch((e) => {
          context.commit('setIsScanning', false);
          context.commit('setIsConnected', false);
          reject(e);
        });
      });
    },
  },
  async disconnectDevice(context) {
    scanner.disconnect();
  },
};
